import { BASE_API_URL, NAME_HEADER_AUTH } from '../utils/Constants'
import getStoredValue from '../services/UseLocalStorage.js'

const getAuthHeaders = () => {
  const token = getStoredValue(NAME_HEADER_AUTH)
  return token ? { Authorization: `Bearer ${token}` } : {}
}

export async function fetchDashboardData(params) {
  const response = await fetch(
    `${BASE_API_URL}/dashboard?${new URLSearchParams(params)}`,
    {
      method: 'GET',
      headers: getAuthHeaders(),
    }
  )
  if (!response.ok) {
    throw new Error('Network response was not ok')
  }
  return await response.json()
}

export async function fetchAdById(id) {
  const response = await fetch('../store.json', {
    method: 'GET',
    headers: getAuthHeaders(),
  })
  if (!response.ok) {
    throw new Error('Network response was not ok')
  }
  const data = await response.json()
  return data.find((ad) => ad.LibraryID === id)
}

export async function deleteAdById(id) {
  const response = await fetch(`${BASE_API_URL}/dashboard`, {
    method: 'DELETE',
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ Id_ad: id }),
  })
  if (!response.ok) {
    throw new Error('Network response was not ok')
  }
  return await response.json()
}

export async function logout() {
  const response = await fetch(`${BASE_API_URL}/logout`, {
    method: 'GET',
    headers: getAuthHeaders(),
  })
  if (!response.ok) {
    throw new Error('Network response was not ok')
  }
  return await response.json()
}

export async function fetchCategories() {
  const response = await fetch(`${BASE_API_URL}usercategory`, {
    method: 'GET',
    headers: getAuthHeaders(),
  })
  if (!response.ok) {
    throw new Error('Network response was not ok')
  }
  return (await response.json()).data
}

export async function fetchAdsByCategory(categoryCode) {
  const response = await fetch(
    `${BASE_API_URL}/usercategory?cat_code=${categoryCode}`,
    {
      method: 'GET',
      headers: getAuthHeaders(),
    }
  )
  if (!response.ok) {
    throw new Error('Network response was not ok')
  }
  return (await response.json()).data
}

export async function assignAdToCategory({ categoryCode, adId }) {
  const response = await fetch(`${BASE_API_URL}/assignCategory`, {
    method: 'POST',
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ Id_ad: adId, cat_code: categoryCode }),
  })
  if (!response.ok) {
    throw new Error('Network response was not ok')
  }
  return (await response.json()).data
}

export async function createCategory(categoryName) {
  const response = await fetch(`${BASE_API_URL}/usercategory`, {
    method: 'POST',
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ Category_Name: categoryName }),
  })
  if (!response.ok) {
    throw new Error('Network response was not ok')
  }
  return await response.json()
}

export async function updateCategory({ categoryCode, categoryName }) {
  const response = await fetch(`${BASE_API_URL}/updateCategory`, {
    method: 'POST',
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      Category_Name: categoryName,
      Cat_Code: categoryCode,
    }),
  })
  if (!response.ok) {
    throw new Error('Network response was not ok')
  }
  return await response.json()
}

export async function deleteCategory(categoryCode) {
  const response = await fetch(`${BASE_API_URL}/usercategory`, {
    method: 'DELETE',
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ Category_Code: categoryCode }),
  })
  if (!response.ok) {
    throw new Error('Network response was not ok')
  }
  return await response.json()
}

export async function translateText({ text, targetLanguage } = {}) {
  const response = await fetch(`${BASE_API_URL}/translate`, {
    method: 'POST',
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ text, targetLanguage }),
  })
  if (!response.ok) {
    throw new Error('Network response was not ok')
  }
  return (await response.json()).translatedText
}

export async function loadCombo(nameCombo) {
  const response = await fetch(`${BASE_API_URL}/loadCombo/${nameCombo}`, {
    method: 'GET',
    headers: getAuthHeaders(),
  })
  if (!response.ok) {
    throw new Error('Network response was not ok')
  }
  return await response.json()
}

export async function createOffer({ id, tracking, url, domUrl }) {
  console.log("domUrl is: ", domUrl)
  console.log("tracking is: ", tracking)
  const response = await fetch(`${BASE_API_URL}/offersFollow`, {
    method: 'POST',
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ID_SavedAd: id,
      Nombre: tracking,
      FanPage: url,
      Domain: domUrl,
    }),
  })
  if (!response.ok) {
    throw new Error('Network response was not ok')
  }
  return await response.json()
}

export async function fetchOffersTracking(id, src) {
  const response = await fetch(
    `${BASE_API_URL}/getOffersTrackingChart?OffersFollo_ID=${Number(
      id
    )}&TrafficSrc=${src}`,
    {
      method: 'GET',
      headers: getAuthHeaders(),
    }
  )
  if (!response.ok) {
    throw new Error('Network response was not ok')
  }
  return (await response.json())
}

export async function deleteOffersTracking(id) {
  const response = await fetch(`${BASE_API_URL}/offersFollow`, {
    method: 'DELETE',
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ OffersFollo_ID: Number(id) }),
  })
  if (!response.ok) {
    throw new Error('Network response was not ok')
  }
  return await response.json()
}

export async function updateOffer({ id, title }) {
  const response = await fetch(`${BASE_API_URL}/offersFollow`, {
    method: 'POST',
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      action: 'rename',
      OffersFollo_ID: Number(id),
      Nombre: title,
    }),
  })
  if (!response.ok) {
    throw new Error('Network response was not ok')
  }
  return await response.json()
}
